<div class="relative isolate flex min-h-svh w-full max-lg:flex-col">
  <main class="hidden lg:flex flex-1 flex-col p-2 lg:min-w-0 w-full">
    <div
      class="grow overflow-hidden relative lg:rounded-lg lg:bg-white dark:bg-zinc-950 px-6 lg:px-10 lg:py-16 lg:shadow-sm lg:ring-1 lg:ring-zinc-950/10 dark:lg:ring-white/10">
      <div class="absolute inset-0">
        <img
          src="assets/images/branding/cover-image.png"
          class="size-full object-cover" alt="" />
      </div>
      <!-- <div class="relative flex flex-col justify-end items-center h-full">
        <h1 class="heading text-center max-w-2xl mx-auto text-pretty">
          Lorem ipsum dolor sit amet <br />
          consectetur, adipisicing elit.
        </h1>
      </div> -->
    </div>
  </main>
  <div
    class="min-h-full lg:w-1/2 flex flex-1 flex-col justify-center px-4 py-12 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
    <div class="mx-auto w-full max-w-sm lg:w-96">
      <div>
        <img class="h-16 w-auto object-scale-down" src="assets/images/branding/logo-login.png" alt="Your Company" />
        <h2 class="mt-8 heading">
          Welcome back!
        </h2>
        <p class="mt-1 text-sm-light">
          Sign in to your account to continue.
        </p>
      </div>
      <div class="mt-10">
        <div>
          <form [formGroup]="signInForm" (ngSubmit)="onSignIn()" class="space-y-6">
            <div>
              <label class="subheading after:ml-0.5 after:text-red-500 after:content-['*']">Email Address</label>
              <div class="mt-2">
                <input id="email" name="email" formControlName="email" type="text" />
                <div *ngIf="form.email.errors && submitted">
                  <div *ngIf="form.email.errors.required" class="error">
                    <p class="mt-2 text-xs text-red-500" id="title-description">Email is required</p>
                  </div>
                  <div *ngIf="form.email.errors.email" class="error">
                    <p class="mt-2 text-xs text-red-500" id="title-description">
                      Invalid Email format
                    </p>
                  </div>
                </div>

              </div>
            </div>
            <div class="space-y-1">
              <label class="subheading after:ml-0.5 after:text-red-500 after:content-['*']">Password</label>
              <div class="flex flex-1 gap-2 items-center">
                <div class="flex-1 relative">
                  <input 
                    formControlName="password" 
                    [type]="showPassword ? 'text' : 'password'" 
                    class="input-class w-full pr-10" 
                  />
                  <span 
                    class="absolute inset-y-0 right-2 flex items-center cursor-pointer text-gray-500"
                    (click)="togglePasswordVisibility()"
                  >
                    <ng-container *ngIf="showPassword; else hideIcon">
                      <!-- Eye Slash Icon (Hide Password) -->
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88" />
                      </svg>
                    </ng-container>
                    <ng-template #hideIcon>
                      <!-- Eye Icon (Show Password) -->
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
                        <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                      </svg>
                    </ng-template>
                  </span>
                </div>
              </div>
            
              <div *ngIf="form.password?.errors && submitted">
                <div *ngIf="form.password?.errors?.required" class="error">
                  <p class="mt-2 text-red-600 text-xs">Password is required</p>
                </div>
              <div *ngIf="form.password?.errors?.minlength" class="error">
                  <p class="mt-2 text-red-600 text-xs">
                      Password must be at least 8 chars with letters & numbers
                  </p>
              </div>
              </div>
          

            </div>
            <div>
              <button type="submit" class="btn btn-primary w-full">
                Sign in
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>